// WORK ORDER
export const GET_WORK_ORDERS = '/work_order/query';
export const GET_WORK_ORDER = '/work_order/';
export const POST_WORK_ORDER = '/work_order/';
export const PUT_WORK_ORDER = '/work_order/';
export const DELETE_WORK_ORDER = '/work_order/';
export const DOWNLOAD_WORK_ORDER = '/work_order/download/';
